import { defineComponent, ref } from 'vue';
import { Auth } from '@nio-pow/mfe-vue3';
import { Dropdown, Doption } from '@nio-pow/cedar-design-web';
export default defineComponent({
    name: 'BizAreaComp',
    components: {
        Dropdown,
        Doption
    },
    props: {},
    setup (props) {
        const bizAreaList = Auth.getBizAreaList();
        const curLesseeInfo = Auth.getUserCurLessee();
        const isActive = ref(false);
        // 执行租户切换
        const handleChangeLessee = (value)=>{
            // 若选择的租户与当前租户相同，则不执行切换操作
            // if (userInfo.lesseeCode === value) return
            Auth.triggerLesseeChange(value);
        };
        const handleActiveStatusChange = (visible)=>{
            isActive.value = visible;
        };
        return {
            isActive,
            bizAreaList,
            curLesseeInfo,
            handleChangeLessee,
            handleActiveStatusChange
        };
    }
});
